// import './chat.scss';

export { default } from './Chat';
export { default as template } from './chat.tpl';
